module.exports = __webpack_public_path__ + "static/servicii-cenzorat-large.fbd0596c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/servicii/servicii-cenzorat-large.jpg
// module id = 469
// module chunks = 141026786960343